import React from "react";
import HomePage from "../../Components/HomePage/HomePage";

const Home = props => {
    return <HomePage />
}

export default Home